import { SDK_NAMESPACE } from '.';

export const CENTRAL_HANDLER = 'visaMessage';
export const RECEIVE_MESSAGE_PATH = `${SDK_NAMESPACE}.InboundHybridHandlers.receiveMessage`;
export const MESSAGE_HANDLERS_PATH = `${SDK_NAMESPACE}.InboundHybridHandlers.messageHandlers`;
